import { render, staticRenderFns } from "./administrationfrequency.vue?vue&type=template&id=bf9dc528&"
import script from "./administrationfrequency.vue?vue&type=script&lang=js&"
export * from "./administrationfrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports